import { Injectable, inject } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { EMPTY, Observable, catchError, map, take } from "rxjs";
import { CmsService } from "libs/cms/src/lib/services/cms.lib.service";
import { CmsBlockPublicKey, PublicDocumentsCmsBlock, CmsBlockModelPublicResponse } from "libs/cms/src/lib/models";
import { NotificationService } from "./notification.lib.service";

@Injectable({
	providedIn: 'root'
})
export class PublicDocumentsResolver implements Resolve<PublicDocumentsCmsBlock> {
	private cmsService = inject(CmsService);
	private notificationService = inject(NotificationService);


	resolve(_route: ActivatedRouteSnapshot): Observable<PublicDocumentsCmsBlock> {
		return this.cmsService.getPublicCmsBlock(CmsBlockPublicKey.PUBLIC_DOCUMENTS).pipe(
			take(1),
			map( (response: CmsBlockModelPublicResponse) => response.content ),
			catchError((error) => {
				this.notificationService.showErrorMessage(
					"ResolvePublicDocumentsError",
					error.status,
					5000
				);
				return EMPTY;
			})
		);
	}
}
